import { render } from "./firms.vue?vue&type=template&id=58f9a2b4&scoped=true"
import script from "./firms.vue?vue&type=script&lang=js"
export * from "./firms.vue?vue&type=script&lang=js"

import "./firms.vue?vue&type=style&index=0&id=58f9a2b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f9a2b4"]])

export default __exports__